import React from 'react';
import { Formik, Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { object, func } from 'prop-types';

// Import validation
import validation from './validate';

// Import components
import { Button, FirebaseAuthField } from 'components/elements';

// Import helpers
import { AUTH_FIELDS_NAMES } from 'components/views/authentication/login/firebase_auth/helpers';

// Import styles
import { SmsInfo } from 'components/views/authentication/login/firebase_auth/style';

const AuthenticationCodeForm = ({ onSubmit, formRef }) => {
	const { t } = useTranslation();

	return (
		<>
			<SmsInfo>{t('common_login_firebase_enter_code')}</SmsInfo>
			<Formik ref={formRef} initialValues={{ code: '' }} validate={validation} onSubmit={onSubmit}>
				{({ handleSubmit, isSubmitting }) => (
					<form onSubmit={handleSubmit}>
						<Field
							placeholder={t('common_login_firebase_code_placeholder')}
							name={AUTH_FIELDS_NAMES.CODE}
							type="text"
							disabled={isSubmitting}
							component={FirebaseAuthField}
						/>
						<Button type="submit" disabled={isSubmitting} width="100%" modifiers="primary">
							{t('common_login_login')}
						</Button>
					</form>
				)}
			</Formik>
		</>
	);
};

AuthenticationCodeForm.propTypes = {
	onSubmit: func.isRequired,
	formRef: object.isRequired
};

export default AuthenticationCodeForm;
